// Modal shown when the IAS SSO client detects an expired amelia session
// (dispatched via `openSessionExpired` in `./state`). Rendered near the app
// root; consumers open it, they don't render it inline. "Sign in again" just
// closes the dialog — by the time we open it, `iasExpireSession` has already
// nulled out the Metabase user and any subsequent navigation to a protected
// route bounces through the SSO login flow on its own.

import { t } from "ttag";

import ErrorBoundary from "metabase/ErrorBoundary";
import { useDispatch, useSelector } from "metabase/redux/hooks";
import { Button, Modal, Stack, Text } from "metabase/ui";

import { closeSessionExpired, getIsSessionExpiredModalOpen } from "./state";

export const SessionExpiredModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsSessionExpiredModalOpen);

  const handleClose = () => {
    dispatch(closeSessionExpired());
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ErrorBoundary>
      <Modal opened withCloseButton={false} onClose={handleClose}>
        <Stack>
          <Text fw="bold" size="xl" c="text-primary">
            {t`You have been signed out`}
          </Text>
          <Text>
            {t`You've been signed out of Amelia. Amelia sessions in all tabs have been signed out.`}
          </Text>
          <Stack align="flex-end">
            <Button onClick={handleClose}>{t`Sign in again`}</Button>
          </Stack>
        </Stack>
      </Modal>
    </ErrorBoundary>
  );
};
